module.exports = __webpack_public_path__ + "static/media/maquininhabanner.76eb8178.png";